import 'bootstrap';

function handleImageModalEvents(): void {
  const imageModalElement = document.getElementById('imageModal');
  const imageModalContentElement = document.getElementById('imageModalContent');

  if (imageModalElement && imageModalContentElement) {
    imageModalElement.addEventListener('show.bs.modal', (event: Event & { relatedTarget: HTMLElement }) => {
      const relatedTarget = event.relatedTarget;
      if (relatedTarget) {
        imageModalContentElement.innerHTML = relatedTarget.innerHTML;
      }
    });

    imageModalElement.addEventListener('hidden.bs.modal', () => {
      imageModalContentElement.innerHTML = '';
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  handleImageModalEvents();
});
